import { Component } from "@angular/core";

@Component({
  selector: "brd-hero-image",
  templateUrl: "./hero-image.component.html",
  styleUrl: "./hero-image.component.less",
  standalone: false
})
export class HeroImageComponent {}
